import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addClosuresReports,
  getClosuresReports,
} from "../../apis/reportClosures";

export const addClosuresReportData = createAsyncThunk(
  "Closures/addClosures",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      // Call the correct API function with optional parameters
      const response = await addClosuresReports(data);
      return response
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const getClosuresReportData = createAsyncThunk(
  "getClosures/getClosuresReport",
  async (
    {
      notification_intro,
      endDate,
      portCalls,
      startDate,
    }: {
      notification_intro: string;
      endDate: any;
      portCalls: string;
      startDate: any;
    },
    { rejectWithValue }
  ) => {
    try {
      // Pass the parameters to the API function
      const response = await getClosuresReports({
        endDate,
        portCalls,
        notification_intro,
        startDate,
      });
      return response.data;
    } catch (error: any) {
      console.error("Error fetching port call notification:", error);
      return rejectWithValue(
        error?.response?.data?.message ||
          error.message ||
          "Failed to fetch port call notification"
      );
    }
  }
);
